exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-container[data-v-63095450] {\n  height: 100%;\n  max-height: 47vh;\n  overflow: auto;\n}\n", ""]);

// exports
